<template>
    <div class="app">
      <Snackbar :snackbar="snackbar" :text="text" @change="snackbar = $event" />
      <v-sheet v-show="showSkeleton" class="pa-3">
        <v-row>
          <v-col>
            <v-skeleton-loader class="mx-auto" type="image" height="220" />
          </v-col>
        </v-row>
      </v-sheet>
        <v-dialog 
            v-show="!showSkeleton"
            v-model="dialog"
            persistent
        >
            <template v-slot:activator="{ on, attrs }">
                <v-btn
                    v-show="!showSkeleton"
                    color="primary"
                    dark
                    v-bind="attrs"
                    v-on="on"
                >
                Estrai
                </v-btn>
            </template>
            <v-card ref="form" >
                <v-card-title>
                    <span class="text-h5">Configuração Estrai</span>
                </v-card-title>
                <v-card-text>
                    <v-row>
                        <v-col>
                            <v-autocomplete
                            dense
                            v-model="form.operador"
                            :items="operadores"
                            label="Operadores"
                            outlined
                            multiple
                            >
                            </v-autocomplete>
                        </v-col>
                        <v-col>
                            <v-text-field
                                dense
                                v-model.number="form.path"
                                label="caminho"
                                type="string"
                                outlined
                                :error-messages="pathErrors"
                            />
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="cancelar()"
                    >
                        Cancelar
                    </v-btn>
                    <v-btn
                        color="blue darken-1"
                        text
                        @click="salvar()"
                    >
                        Salvar
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
  </template>
  
  <script>
  import { mapGetters, mapActions} from 'vuex'
  
  import Snackbar from '@/componentes/Snackbar'
  import { registerVuexModule } from '@/utils/vuexUtils'
  import { validateDataIa, validateComputedIa } from '../_validates'
  
  import IntegracoesStore from '../_store'
  import IntegracoesHttpServices from '../_services/IntegracoesHttpService'
  
  export default {
    name: 'AbaIa',
    props: {
      _id: String,
    },
    components: { Snackbar },
  
    data: () => ({
        form: {
            operador:[],
            path:'',
        },
        operadores:[],
        dialog: false,
        pararLoader: {
            parar: false,
        },
        showSkeleton: true,
        text: '',
        snackbar: false,
    }),
    
     validations: {
         ...validateDataIa,
     },
  
  
    computed: {
        ...validateComputedIa,
        ...mapGetters('AbaIAModulePABXStore', ['getIa','getOperadores']),
        todosoperadoresSelecionados() {
            return this.form.operadores.length === this.operadores.length
        },
        algunsoperadoresSelecionados() {
            return this.form.operadores.length > 0 && !this.todosoperadoresSelecionados
        },
        iconoperadores() {
            if (this.todosoperadoresSelecionados) return 'mdi-close-box'
            if (this.algunsoperadoresSelecionados) return 'mdi-minus-box'
            return 'mdi-checkbox-blank-outline'
        },
       
    },
  
    async created() {
        registerVuexModule(this.$store, 'AbaIAModulePABXStore', IntegracoesStore)

        await this.listaOperadores() 
        await this.listaIntegracaoIA()

        this.operadores = this.getOperadores.map(operador => ({ text: operador.usuario, value: operador.numero }))
        
        if (this.getIa) {
            this.form = {...this.getIa}
        }
        this.showSkeleton = false
    },
  
    methods: {
        ...mapActions('AbaIAModulePABXStore', ['listaOperadores','listaIntegracaoIA']),
        toggleoperadores() {
            this.$nextTick(() => {
                if (this.todosoperadoresSelecionados) {
                    this.form.operadores.splice(0)
                } else {
                    this.form.operadores.splice(0)
                    this.form.operadores = this.operadores.map(ramal => ramal.value)
                }
            })
        },

        async salvar() {
            this.pararLoader.parar = false
            this.$v.$touch()
            if (this.$v.$error) {
                this.$vuetify.goTo(1, { duration: 1000, easing: 'easeOutCubic' })
                this.pararLoader.parar = true
                return
            }
            try {
                await IntegracoesHttpServices.postintegracaoIA(this.form);
            } catch (error) {
                let key = Object.keys(error.response.data)
                this.text = error.response.data[key[0]]
                this.pararLoader.parar = true
                this.snackbar = true
            }
            this.dialog = false
           
        },
        cancelar() {
            this.dialog = false
        },
    },
  }
  </script>
  
  <style scoped>
  .app {
    background-color: var(--v-background-base);
  }
  </style>
  